<template>
  <div
    class="fixed top-20 right-6 flex flex-col gap-4 pointer-events-none"
    style="z-index: 20;"
  >
    <transition-group
      name="alert-list"
      tag="div"
      class="flex flex-col gap-4 items-end pointer-events-auto"
    >
      <AccountAlertItem
        v-for="alert in alerts"
        :key="alert.id"
        :title="alert.title"
        :message="alert.message"
        :actionLabel="alert.actionLabel"
        :icon="alert.icon"
        @close="onClose(alert.id)"
        @action="onAction(alert)"
      />
    </transition-group>
  </div>
</template>

<script>
import AccountAlertItem from "./AccountAlertItem.vue";

export default {
  name: "AccountAlertContainer",
  props: {
    alerts: {
      type: Array,
      default: () => []
    }
  },
  components: {
    AccountAlertItem
  },
  emits: ["close"],
  methods: {
    onClose(id) {
      this.$emit("close", id);
    },
    onAction(alert) {
      if (alert.onAction) {
        alert.onAction();
      }
    }
  }
};
</script>

<style scoped>
.alert-list-enter-active,
.alert-list-leave-active {
  transition: all 0.4s ease;
}
.alert-list-enter-from {
  opacity: 0;
  transform: translateX(30px);
}
.alert-list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
